module.exports = __webpack_public_path__ + "img/1f991.21821f2.svg";